import LoadingSkeleton from "./loading_skeleton.tsx";
import { SecondaryBody } from "@sprout/typography.tsx";
import useTranslation from "@hooks/use_translation.ts";
import useTimeSinceDateText from "@hooks/use_time_since_date_text.ts";

type Props = {
  loading?: boolean;
  publishedAt: string;
  viewed: boolean;
  appliedAt: string | null;
};

const Footer = ({ loading, publishedAt, viewed, appliedAt }: Props) => {
  const { t } = useTranslation("jobSearch");
  const timeSincePublished = useTimeSinceDateText(publishedAt, "posted");
  const timeSinceApplied = useTimeSinceDateText(appliedAt ?? "", "applied");

  return loading ? (
    <LoadingSkeleton className="h-4 w-[80px]" />
  ) : (
    <SecondaryBody>
      {timeSincePublished}
      {appliedAt && ` • ${timeSinceApplied}`}
      {viewed && !appliedAt && ` • ${t("viewed")}`}
    </SecondaryBody>
  );
};

export default Footer;
